var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import Image from './Image';
import ClassNames from './Image.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import { BlockTypes } from '@cvent/carina-rich-text-renderer';
import renderRichText from '../../utils/renderRichText';
import getImageFromLookup from '../../utils/getImageFromLookup';
/**
 * Data wrapper for the Image widget.
 */
var ImageWidget = /** @class */ (function (_super) {
    __extends(ImageWidget, _super);
    function ImageWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageWidget.prototype.getImageContainerAlignment = function (textAlignValue) {
        // Map textAlign values to respective flex variants
        var alignMapping = {
            'left': 'flex-start',
            'right': 'flex-end',
            'center': 'center',
            'justify': 'space-between'
        };
        return alignMapping[textAlignValue];
    };
    ImageWidget.prototype.getStyleObject = function () {
        // The style set in the canvas for the image alignment actually needs to be applied to the container.
        // There is no textAlign style option for the container, so we can just merge the alignment style in here.
        return {
            container: __assign(__assign({}, _super.prototype.getStyleObject.call(this).container), { justifyContent: this.getImageContainerAlignment(this.getElementText('image').textAlign) }),
            image: this.getElementText('image'),
            imageText: this.getElementInlineStyle('imageText')
        };
    };
    ImageWidget.prototype.render = function () {
        var _a = this.props, classes = _a.classes, config = _a.config, translate = _a.translate, enableHyperlink = _a.enableHyperlink, style = _a.style, imageLookup = _a.imageLookup, onLoad = _a.onLoad, breakpoints = _a.breakpoints, _b = _a.browserFeatures, _c = _b === void 0 ? {} : _b, supportsWebp = _c.supportsWebp;
        var styleObject = this.getStyleObject();
        var imageUrl = config.asset ? config.asset.assetUri : '';
        var _d = getImageFromLookup(imageLookup, translate(imageUrl)), url = _d.hashedURL, width = _d.width;
        return React.createElement(Image, __assign({}, resolveTestId(this.props), onLoad ? {
            onLoad: onLoad
        } : {}, { classes: classes, style: styleObject, imgUrl: url, altText: config.altText, width: width, breakpoints: breakpoints, hyperlink: enableHyperlink && config.hyperlink, description: renderRichText(config.description, translate, style.palette, styleObject.imageText, {
                baseBlockType: config.baseBlockType
            }), translate: translate, supportsWebp: supportsWebp }));
    };
    ImageWidget.displayName = 'ImageWidget';
    ImageWidget.propTypes = {
        type: PropTypes.string,
        breakpoints: PropTypes.arrayOf(PropTypes.number),
        config: PropTypes.shape({
            asset: PropTypes.object,
            altText: PropTypes.string,
            hyperlink: PropTypes.string,
            description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
            baseBlockType: PropTypes.oneOf(Object.values(BlockTypes))
        }),
        classes: PropTypes.object,
        style: PropTypes.object,
        translate: PropTypes.func,
        enableHyperlink: PropTypes.bool,
        onLoad: PropTypes.func,
        browserFeatures: PropTypes.shape({
            supportsWebp: PropTypes.bool
        })
    };
    ImageWidget.defaultProps = {
        classes: ClassNames,
        breakpoints: [320, 480, 768, 992]
    };
    return ImageWidget;
}(BaseWidget));
export default ImageWidget;
